// extracted by mini-css-extract-plugin
export var expandButton = "transport-title-module--expand-button--46349";
export var expanded = "transport-title-module--expanded--05027";
export var transportTitle = "transport-title-module--transportTitle--09127";
export var transportTitleActionButton = "transport-title-module--transportTitleActionButton--9d7d3";
export var transportTitleContent = "transport-title-module--transportTitleContent--12b4b";
export var transportTitleDescription = "transport-title-module--transportTitleDescription--1d942";
export var transportTitleImageBox = "transport-title-module--transportTitleImageBox--bcd67";
export var transportTitleLabel = "transport-title-module--transportTitleLabel--c0821";
export var truncateContent = "transport-title-module--truncate-content--a97e4";
export var truncateOverflow = "transport-title-module--truncate-overflow--8be3d";